import client from "./client";

export const listNewsletterEntries = (page = 1, limit = 20) =>
  client.post("/newsletterentry/list", { page, limit });

export const deleteNewsletterEntry = (id) =>
  client.post("/newsletterentry/delete", { id });
